import type {
  CompanyRegistration,
  CompanyRegistrationCreateInput,
  CompanyRegistrationUpdateInput,
  FieldGroupEnum,
  SignedUrl,
} from "@/graphql/codegen/graphql"
import { CompanyRegistrationType } from "@/graphql/codegen/graphql"
import type { RegistrationFormValues } from "@/screens/CompanySettings/Registration/forms/registrationSchema"

export const getRegistrationNumberPlaceholder = (registrationType?: CompanyRegistrationType): string => {
  switch (registrationType) {
    case CompanyRegistrationType.Federal:
      return "Company Federal Registration Number"
    case CompanyRegistrationType.State:
      return "State Registration Number"
    case CompanyRegistrationType.Local:
      return "Local Registration Number"
    default:
      return "Input number"
  }
}

export const buildDefaultFormValues = (data: CompanyRegistration): RegistrationFormValues => {
  return {
    companyId: data.companyId!,
    companyRegistrationId: data.companyRegistrationId!,
    registrationType: data.registrationType as CompanyRegistrationType,
    locationId: data.locationId!,
    registrationNumber: data.registrationNumber!,
    taxExemptionNumber: data.taxExemptionNumber ?? "",
    registrationDocument: undefined,
    taxExemptionDocument: undefined,
  }
}

export const serializeCreateInput = (input: RegistrationFormValues): CompanyRegistrationCreateInput => {
  return {
    companyId: input.companyId,
    registrationType: input.registrationType as CompanyRegistrationType,
    registrationNumber: input.registrationNumber,
    ...(input.registrationType !== CompanyRegistrationType.Federal && {
      locationId: input.locationId,
      taxExemptionNumber: input.taxExemptionNumber,
    }),
  }
}

export const serializeUpdateInput = (input: RegistrationFormValues): CompanyRegistrationUpdateInput => {
  return {
    companyRegistrationId: input.companyRegistrationId as string,
    registrationNumber: input.registrationNumber,
    ...(input.registrationType !== CompanyRegistrationType.Federal && {
      locationId: input.locationId,
      taxExemptionNumber: input.taxExemptionNumber,
    }),
  }
}

export const normalizeFileData = (fileData: SignedUrl[], fieldGroup: FieldGroupEnum): Record<string, SignedUrl> => {
  return fileData.reduce(
    (acc, item) => {
      if (item.file?.referenceId && item.file.fieldGroup === fieldGroup) {
        acc[item.file.referenceId] = item
      }
      return acc
    },
    {} as Record<string, SignedUrl>
  )
}
